import React, { useState } from "react";
import PavingPhoto1 from "../../images/services/paving.jpg";
import PavingPhoto2 from "../../images/services/DSC_2376.jpg";
import PavingPhoto3 from "../../images/services/DSC_0732.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";

function PavingStriping() {
  const slides = [PavingPhoto1, PavingPhoto2, PavingPhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Paving & Striping</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Paving & Striping</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-paving-detail">
        <div className="container">
          <div className="row brw-paving-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-paving-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-paving-detail__service-list">
                  <li>
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li>
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li className="active">
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li>
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li>
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-paving-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>Central Florida & Surrounding Areas</p>
                </div>

                <div className="brw-paving-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>Mon–Fri: 8:00 AM – 5:00 PM</p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-paving-detail__showcase">
                {/* SLIDER */}
                <div className="brw-paving-detail__media">
                  <button
                    className="brw-paving-detail__arrow brw-paving-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Paving Slide"
                    className="brw-paving-detail__image"
                  />
                  <button
                    className="brw-paving-detail__arrow brw-paving-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <div className="brw-paving-detail__copy">
                  <h4>
                    Professional Asphalt Paving And Line Striping For Your
                    Project
                  </h4>
                  <p>
                    BRW Contracting provides professional asphalt paving and
                    parking lot striping. We handle projects of any size,
                    ensuring durability, precision, and aesthetic appeal.
                  </p>
                  <p>
                    Our experienced team and advanced equipment guarantee
                    high-quality results for residential, commercial, and
                    industrial projects.
                  </p>
                  <div className="brw-paving-detail__chips">
                    <span>Asphalt paving</span>
                    <span>Parking lot striping</span>
                    <span>Roadway finishes</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STYLES */}
      <style jsx>{`
        .brw-paving-detail {
          padding: 64px 0 82px;
          background:
            linear-gradient(180deg, #f7f9fc 0%, #eef3f9 100%);
        }

        .brw-paving-detail__layout {
          row-gap: 30px;
        }

        .brw-paving-detail__sidebar {
          position: sticky;
          top: 110px;
          overflow: hidden;
          background:
            linear-gradient(180deg, #10366f 0%, #082653 100%);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;
          padding: 28px;
          box-shadow: 0 26px 60px rgba(12, 45, 98, 0.18);
        }

        .brw-paving-detail__sidebar::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(
            135deg,
            rgba(255, 168, 0, 0.16),
            rgba(255, 168, 0, 0) 34%
          );
        }

        .brw-paving-detail__sidebar h4 {
          position: relative;
          color: #ffa800;
          margin-bottom: 22px;
          font-size: 1.45rem;
          font-weight: 800;
        }

        .brw-paving-detail__service-list {
          position: relative;
          margin: 0 0 24px;
          padding: 0;
          list-style: none;
        }

        .brw-paving-detail__service-list li {
          margin: 0;
        }

        .brw-paving-detail__service-list a {
          display: flex;
          align-items: center;
          min-height: 43px;
          padding: 0 14px;
          border-radius: 6px;
          color: #e8eef8;
          font-weight: 700;
          transition:
            background 0.22s ease,
            color 0.22s ease,
            transform 0.22s ease;
        }

        .brw-paving-detail__service-list a::before {
          content: "";
          width: 5px;
          height: 5px;
          margin-right: 12px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.58);
          transition: background 0.22s ease, transform 0.22s ease;
        }

        .brw-paving-detail__service-list a:hover,
        .brw-paving-detail__service-list li.active a {
          background: rgba(255, 255, 255, 0.1);
          color: #ffa800;
          transform: translateX(2px);
        }

        .brw-paving-detail__service-list a:hover::before,
        .brw-paving-detail__service-list li.active a::before {
          background: #ffa800;
          transform: scale(1.28);
        }

        .brw-paving-detail__info-card {
          position: relative;
          background: rgba(255, 255, 255, 0.11);
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;
          padding: 22px 18px;
          margin-top: 14px;
          text-align: center;
        }

        .brw-paving-detail__info-card svg {
          font-size: 1.55rem;
          color: #ffa800;
          margin-bottom: 10px;
        }

        .brw-paving-detail__info-card h5 {
          color: #ffa800;
          font-size: 1.02rem;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .brw-paving-detail__info-card p {
          color: #f5f8ff;
          margin: 0;
          font-size: 0.92rem;
          line-height: 1.45;
        }

        .brw-paving-detail__showcase {
          overflow: hidden;
          background: rgba(255, 255, 255, 0.92);
          border: 1px solid rgba(12, 45, 98, 0.1);
          border-radius: 8px;
          padding: 10px;
          box-shadow: 0 28px 70px rgba(12, 45, 98, 0.15);
        }

        .brw-paving-detail__media {
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          background: #081f45;
        }

        .brw-paving-detail__media::after {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(
            90deg,
            rgba(5, 21, 49, 0.34),
            rgba(5, 21, 49, 0) 28%,
            rgba(5, 21, 49, 0) 72%,
            rgba(5, 21, 49, 0.34)
          );
          z-index: 1;
        }

        .brw-paving-detail__image {
          display: block;
          width: 100%;
          height: 430px;
          object-fit: cover;
          transform: scale(1.01);
          transition: transform 0.45s ease;
        }

        .brw-paving-detail__media:hover .brw-paving-detail__image {
          transform: scale(1.045);
        }

        .brw-paving-detail__arrow {
          position: absolute;
          z-index: 2;
          top: 50%;
          transform: translateY(-50%);
          width: 38px;
          height: 58px;
          border-radius: 999px;
          border: 1px solid rgba(255, 255, 255, 0.38);
          background: rgba(9, 33, 74, 0.7);
          color: #fff;
          font-size: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
          backdrop-filter: blur(12px);
          transition:
            transform 0.22s ease,
            background 0.22s ease,
            border-color 0.22s ease,
            color 0.22s ease;
        }

        .brw-paving-detail__arrow::before {
          font-size: 1.9rem;
          font-weight: 400;
          line-height: 1;
        }

        .brw-paving-detail__arrow:hover {
          transform: translateY(-50%) scale(1.04);
          background: #ffa800;
          border-color: rgba(255, 168, 0, 0.9);
          color: #0c2d62;
        }

        .brw-paving-detail__arrow:focus-visible {
          outline: 3px solid rgba(255, 168, 0, 0.42);
          outline-offset: 3px;
        }

        .brw-paving-detail__arrow--prev {
          left: 16px;
        }

        .brw-paving-detail__arrow--prev::before {
          content: "‹";
        }

        .brw-paving-detail__arrow--next {
          right: 16px;
        }

        .brw-paving-detail__arrow--next::before {
          content: "›";
        }

        .brw-paving-detail__copy {
          padding: 30px 28px 24px;
        }

        .brw-paving-detail__copy h4 {
          max-width: 780px;
          color: #0c2d62;
          font-size: 1.8rem;
          line-height: 1.18;
          font-weight: 900;
          margin-bottom: 14px;
        }

        .brw-paving-detail__copy p {
          max-width: 820px;
          color: #58677d;
          font-size: 1rem;
          line-height: 1.72;
          margin-bottom: 10px;
        }

        .brw-paving-detail__chips {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 22px;
        }

        .brw-paving-detail__chips span {
          display: inline-flex;
          align-items: center;
          min-height: 34px;
          padding: 0 13px;
          border: 1px solid rgba(12, 45, 98, 0.12);
          border-radius: 999px;
          background: #f7f9fc;
          color: #0c2d62;
          font-size: 0.88rem;
          font-weight: 800;
        }

        @media (max-width: 991px) {
          .brw-paving-detail__sidebar {
            position: relative;
            top: auto;
          }
        }

        @media (max-width: 768px) {
          .brw-paving-detail {
            padding: 44px 0 58px;
          }

          .brw-paving-detail__image {
            height: 300px;
          }

          .brw-paving-detail__copy {
            padding: 24px 18px 18px;
          }

          .brw-paving-detail__copy h4 {
            font-size: 1.45rem;
          }

          .brw-paving-detail__arrow {
            width: 34px;
            height: 52px;
          }

          .brw-paving-detail__arrow--prev {
            left: 10px;
          }

          .brw-paving-detail__arrow--next {
            right: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default PavingStriping;
